<app-dialog
	modalTitle="Clientes e organizações"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="saveItems()"
>
	<div class="org-list-modal__search">
		<mat-form-field appearance="outline" subscriptSizing="dynamic">
			<mat-label>Pesquisar</mat-label>
			<input
				type="text"
				matInput
				placeholder="Digite o nome da organização"
				[formControl]="searchControl"
			/>
			<button
				*ngIf="!hasActiveSearch"
				matSuffix
				mat-icon-button
				color="primary"
				aria-label="Pesquisar organizações"
				(click)="filterOrganizations()"
			>
				<mat-icon>search</mat-icon>
			</button>
			<button
				*ngIf="hasActiveSearch"
				matSuffix
				mat-icon-button
				color="primary"
				aria-label="Limpar pesquisa"
				(click)="onClearSearch()"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
	</div>

	<p
		*ngIf="hasActiveSearch && filteredOrganizations.length === 0"
		class="org-list-modal__empty"
	>
		Nenhuma organização encontrada.
	</p>

	<ul class="mb-fix">
		<ng-container
			*ngFor="let org of filteredOrganizations; trackBy: trackByOrganizationId"
		>
			<li>
				<mat-checkbox
					color="primary"
					class="ml-xs mt-nano mb-nano"
					[checked]="resultIds.includes(org.id)"
					[disabled]="data.disabled === org.id"
					(change)="onCheckboxToggle(org.id, $event.checked)"
				>
					{{ org.name }}
				</mat-checkbox>
			</li>
			<li *ngFor="let sub of org.secondary; trackBy: trackByOrganizationId">
				<mat-checkbox
					color="primary"
					class="ml-md mt-nano mb-nano"
					[checked]="resultIds.includes(sub.id)"
					[disabled]="data.disabled === sub.id"
					(change)="onCheckboxToggle(sub.id, $event.checked)"
				>
					{{ sub.name }}
				</mat-checkbox>
			</li>
		</ng-container>
	</ul>
</app-dialog>
